<template>
    <div class="container">
        <content-header title="Новости"/>
        <div class="blog-container-list">
            <ArticleHome routeName="articleDetail" :key="data.id" :data="data" v-for="data in news"/>
        </div>

    </div>
</template>

<script>
import ContentHeader from "../components/layout/ContentHeader";
import ArticleHome from "../components/ArticleHome";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "blog",
    components: {
        ContentHeader,
        ArticleHome
    },
    data() {
        return {
            blogData: "" +
                    "<p>на базе неврологического отделения Поликлиники Руководит направлением Мененкова Елена Юрьевна, врач – невролог, высшей квалификационной категории, кандидат медицинских наук, заведующий неврологическим, отделением. Елена Юрьевна имеет большой опыт лечения пациентов неврологического профиля, в т.ч. ОНМК, аутоиммунных заболеваний нервной системы (миастения, рассеяный склероз, ХВДП, ОДПН, полимиозит), болевых синдромов при дегенеративных заболеваниях позвоночника, грыжах межпозвоночных дисков. Выполняет паравертебральные</p>"
        }
    },

    computed: {
        ...mapGetters(["news"])
    },

    methods: {
        ...mapActions(["fetchNews"])
    },

    mounted() {
        this.fetchNews();
    }
}
</script>

<style scoped>

</style>

<style lang="scss">
.news-item {
    width: unset !important;
}

.news-content {
    width: 600px !important;
}

.blog-container-list .article-detail-top {
    display: flex;
    flex-direction: column-reverse;
}

@media screen and (max-width: 768px) {
    .blog-container-list .article-detail__content {
        justify-content: center;
        width: 100%;

    }
}

</style>